import { render, staticRenderFns } from "./UserTagList.vue?vue&type=template&id=1b35cb5b"
import script from "./UserTagList.vue?vue&type=script&lang=js"
export * from "./UserTagList.vue?vue&type=script&lang=js"
import style0 from "./UserTagList.vue?vue&type=style&index=0&id=1b35cb5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports